/**
 * Reflect total unread into document.title.
 *
 * Telegram / Discord prefix the browser tab title with "(N) " when there
 * are unreads. Mentions take priority with "(@N) ". This is the cheapest
 * way to surface "you have stuff waiting" to a user with the tab muted
 * in the background.
 *
 * We don't need a full hook — install once at boot, subscribe to the
 * data store, write document.title on every change. The base title is
 * captured at install time so we can restore it when everything's read.
 */

import { useDataStore } from '@/stores/dataStore';

let baseTitle = '';

function compose(total: number, mentions: number): string {
  if (mentions > 0) {
    return `(@${mentions > 9 ? '9+' : mentions}) ${baseTitle}`;
  }
  if (total > 0) {
    return `(${total > 99 ? '99+' : total}) ${baseTitle}`;
  }
  return baseTitle;
}

export function installUnreadTitle(): () => void {
  if (typeof document === 'undefined') return () => undefined;
  baseTitle = document.title || 'Bunker';
  const apply = () => {
    const state = useDataStore.getState();
    let total = 0;
    let mentions = 0;
    for (const v of Object.values(state.unreadByChannel)) total += v ?? 0;
    for (const v of Object.values(state.mentionByChannel)) mentions += v ?? 0;
    document.title = compose(total, mentions);
  };
  apply();
  return useDataStore.subscribe(apply);
}
